import TypeformUrls from "./TypeformUrls";

const TypeformContent = {
  ACCOUNT_PAYABLE: {
    description:
      "You have to decide when to pay your suppliers. Your supplier provides the materials you use to produce your products. You can decide to pay your suppliers in 0, 30, 60, or 90 days from when the purchase occurred. This decision impacts Working Capital.",
    learnMoreAbout: "Working Capital",
    typeformUrl: TypeformUrls.WORKING_CAPITAL
  },
  ACCOUNT_RECEIVABLE: {
    description:
      "You have to decide when a customer has to pay you. You have the option of offering the customers to pay you in 0, 30, 60, or 90 days from when the sale occurred. This decision impacts Working Capital.",
    learnMoreAbout: "Working Capital",
    typeformUrl: TypeformUrls.WORKING_CAPITAL
  },
  BALANCE_SHEET: {
    description:
      "Balance Sheet reports the net balances of all of your activities since inception of your business. Assets, Liabilities, and Equities are the 3 key accounts within the Balance Sheet. All your team decisions are reflected in these 3 accounts.",
    learnMoreAbout: "the Balance Sheet",
    typeformUrl: TypeformUrls.BALANCE_SHEET
  },
  BUSINESS_VALUATION: {
    description:
      "This is the value of your business. Investors use different valuation methods at different stages (i.e. rounds) of the game.",
    learnMoreAbout: "how your business valued in this game",
    typeformUrl: TypeformUrls.BUSINESS_VALUATION
  },
  CAPITAL_STRUCTURE: {
    description:
      "This is the funding structure of your business. It is the different sources of capital (i.e. funds) that a business uses for their operation. For example, a business might raise $100 for their operations by issuing $80 in equity ( i.e. gave up some ownership) and $20 in debt (i.e. borrowing money). Therefore, their capital structure would be 80% equity 20% debt. Capital Structure metrics can also signal to investors the risks and value of a business.",
    learnMoreAbout: "Capital Structure",
    typeformUrl: TypeformUrls.CAPITAL_STRUCTURE
  },
  CASH_BALANCE: {
    description:
      "This breaks down your current cash balance by giving you a detail breakdown of your cash activities. It provides your cash balance at the beginning of the year and then adjust that balance with the spending budgets from your departments (i.e. Product Development, Product Marketing, and Operations). The balance is then further adjusted by any money raised by your department. You want to make sure that this balance is not low or negative.",
    learnMoreAbout: "the Cash Balance",
    typeformUrl: TypeformUrls.CASH_FLOWS
  },
  CASH_FLOWS: {
    description:
      "Cash Flows reports a detailed breakdown of your cash activities within the year. It helps you better understand how cash is being used within your organization.",
    learnMoreAbout: "Cash Flows",
    typeformUrl: TypeformUrls.CASH_FLOWS
  },
  COMPETITIVE_ANALYSIS: {
    description: "This section provides data on your competitors.",
    learnMoreAbout: "Competitive Analysis",
    typeformUrl: TypeformUrls.COMPETITIVE_ANALYSIS
  },
  COST_OF_CAPITAL: {
    description:
      "It is the cost of raising funds for your business. It is the combined cost of raising debt and equity to fund your business. Managers use the cost of capital metric to evaluate the cost-benefit of a project and investors use the cost of capital to assess the risks and overall value of your business (i.e. your stock price).",
    learnMoreAbout: "Cost of Capital",
    typeformUrl: TypeformUrls.COST_OF_CAPITAL
  },
  DEBT_TO_CAPITAL: {
    description:
      "Debt to Capital is the % of the capital of your business that is financed by debt. The higher your debt to capital ratio, the higher your financing costs.",
    learnMoreAbout: "Debt to Capital",
    typeformUrl: TypeformUrls.DEBT_TO_CAPITAL
  },
  DEBT_VS_EQUITY: {
    description:
      "As Head of Finance, you have to decide if you will raise debt capital to finance your business. Debt is money borrowed that has to be repaid at a specific date. Also, you are obligated to make annual payments of interests each year until the loan is repaid.",
    learnMoreAbout: "debt",
    typeformUrl: TypeformUrls.DEBT_VS_EQUITY
  },
  DISCOUNT_RATE: {
    description:
      "Discount rate has many meanings. In this game, the discount rate is the rate that you use to discount future cash flows to determine those cash flows present value. For capital investment decisions (i.e. buying machine decisions), the discount rate = cost of capital.",
    learnMoreAbout: "the discount rates",
    typeformUrl: TypeformUrls.DISCOUNT_RATE
  },
  EARNINGS_PER_SHARE: {
    description:
      "Earnings Per Share is a ratio that investors use to assess the attractiveness of your your business. The formula is Profits divided by total shares outstanding.",
    learnMoreAbout: "Earnings Per Share",
    typeformUrl: TypeformUrls.EARNINGS_PER_SHARE
  },
  EARNINGS_YIELD: {
    description:
      "Earnings Yield tells investors how much profits a company earned given the company’s value. It is a ratio that takes your Net Profits and divide it by your business’s value.",
    learnMoreAbout: "Earnings Yield",
    typeformUrl: TypeformUrls.EARNINGS_YIELD
  },
  EQUITY_OFFERING: {
    description:
      "As Head of Finance, you need to raise equity capital (i.e. give up some ownership of your business in exchange for money). Equity capital is raised by issuing shares, which represent an ownership stake of your business.",
    learnMoreAbout: "Issuing Shares",
    typeformUrl: TypeformUrls.EQUITY_OFFERING
  },
  FINANCIAL_ANALYSIS: {
    description:
      "This section compares your projections (i.e. plans) with your actual performance.",
    learnMoreAbout: "financial analysis",
    typeformUrl: TypeformUrls.FINANCIAL_ANALYSIS
  },
  FINANCIAL_PLANNING_ANALYSIS: {
    description:
      "This page compares your team’s financial projections (i.e. expectations) with your actual performance. Essentially, it assesses how well your team met expectations. The accuracy in your prediction could have a positive impact on your stock price.",
    learnMoreAbout: "financial, planning, and analysis",
    typeformUrl: TypeformUrls.FINANCIAL_ANALYSIS
  },
  FINANCIALS: {
    description:
      "Financials are reports that translate your team decisions into financial results. Income Statement, Cash Flows, and the Balance Sheet are the key financials that you should review each round. Your 4 KPIs are mainly derived from your financials.",
    learnMoreAbout: "financial statements",
    typeformUrl: TypeformUrls.FINANCIALS
  },
  GROSS_PROFITS: {
    description:
      "This is your revenues (income earned) less the direct costs you incurred to earn those revenues. Revenues - Cost of Sales = Gross Profits.",
    learnMoreAbout: "Profits",
    typeformUrl: TypeformUrls.PROFITABILITY
  },
  INCOME_STATEMENT: {
    description:
      "Income Statement reports your profits earned during the year. It breaks down your profits by income earned (i.e. revenues) and cost incurred (i.e. expenses) during the year.",
    learnMoreAbout: "Income Statements",
    typeformUrl: TypeformUrls.INCOME_STATEMENT
  },
  INVESTOR_DATA: {
    description: "This section has the data that your investors care about.",
    learnMoreAbout: "investment analysis",
    typeformUrl: TypeformUrls.INVESTOR_DATA
  },
  IRR: {
    description:
      "Internal Rate of Return is a metric used in capital investments decisions (e.g. buying machines decision). It measures the return that you have to make on an investment to cover the costs of that investment.",
    learnMoreAbout: "IRR",
    typeformUrl: TypeformUrls.IRR
  },
  KPI: {
    description:
      "KPIs (i.e. Key Performance Indicators) are ratios that management/investors use to measure a business ability to reach their targets/goals (i.e. measure success). Your grade is based on these 4 KPIs.",
    learnMoreAbout: "KPIs",
    typeformUrl: TypeformUrls.KPI
  },
  MARKET_ANALYSIS: {
    description: "This section has customer information.",
    learnMoreAbout: "Market Analysis",
    typeformUrl: TypeformUrls.MARKET_ANALYSIS
  },
  MARKET_CAP: {
    description:
      "Your market capitalization is one of the key metrics used in determining your grades.",
    learnMoreAbout: "Market Capitalization",
    typeformUrl: TypeformUrls.MARKET_CAP
  },
  NET_PROFITS: {
    description:
      "This is your Profits before taxes less income taxes. It’s also known as net income or net earnings.",
    learnMoreAbout: "Profits",
    typeformUrl: TypeformUrls.PROFITABILITY
  },
  NPV_ANALYSIS: {
    description:
      "As Head of Operations, you have to make a decision on which machine(s) to buy to produce your products. Conducting a cost-benefit analysis (i.e. NPV analysis) can help you in this decision. Essentially, you are evaluating the costs of buying machines with the benefits those machines offer (i.e. producing units that you can sell for income).",
    learnMoreAbout: "NPV Analysis",
    typeformUrl: TypeformUrls.NPV_ANALYSIS
  },
  PRICE_EARNINGS_RATIO: {
    description:
      "This is a ratio that investors use to assess if a company is under or overvalued. Investors use this metrics to make a comparison with asimilar businesses.",
    learnMoreAbout: "Valuation Multiples",
    typeformUrl: TypeformUrls.BUSINESS_VALUATION
  },
  PRICE_SALES_RATIO: {
    description:
      "This is a ratio that investors use for a variety of reasons, which include using the ratio to value your business or comparable businesses.",
    learnMoreAbout: "Valuation Multiples",
    typeformUrl: TypeformUrls.BUSINESS_VALUATION
  },
  PRICE_TO_BOOK_RATIO: {
    description:
      "This is a ratio that investors use for a variety of reasons, which include using the ratio to value your business or comparable businesses.",
    learnMoreAbout: "Valuation Multiples",
    typeformUrl: TypeformUrls.BUSINESS_VALUATION
  },
  PERCEPTUAL_MAP: {
    description:
      "This section displays where your product features are in relation to your competitors’ and to what customers are demanded.",
    learnMoreAbout: "Perceptual Map",
    typeformUrl: TypeformUrls.PERCEPTUAL_MAP
  },
  PRICING: {
    description:
      "This section displays the weighted average price of all your products in relation to your competitors’.",
    learnMoreAbout: "Pricing",
    typeformUrl: TypeformUrls.PRICING
  },
  PRODUCT_AWARENESS: {
    description:
      "This section displays the % of customers that are aware of all your products.",
    learnMoreAbout: "Marketing",
    typeformUrl: TypeformUrls.PRODUCT_AWARENESS
  },
  PRODUCT_COSTS: {
    description:
      "Cost per unit of a product is also known as the product’s costs. This costs is made up of 3 key components - Material Costs, Labor Costs, and Overhead Costs.",
    learnMoreAbout: "product costs",
    typeformUrl: TypeformUrls.PRODUCT_COSTS
  },
  PROFITS: {
    description:
      "Your cumulative profits is one of the key metrics used in determining your grades.",
    learnMoreAbout: "Profits",
    typeformUrl: TypeformUrls.PROFITABILITY
  },
  PROJECTIONS: {
    description:
      "This is where you predict what profits you plan to make over the next 3 years. In this module, you input your expected revenues, cost of sales, and other expenses. Your predictions are required to raise capital. Also, your stock price is impacted by the accuracy of your predictions.",
    learnMoreAbout: "management projections",
    typeformUrl: TypeformUrls.FINANCIAL_PROJECTIONS
  },
  ROIC: {
    description:
      "Your ROIC (i.e. Return on Invested Capital) is one of the key metrics used in determining your grades.",
    learnMoreAbout: "ROIC",
    typeformUrl: TypeformUrls.ROIC
  },
  ROIC_KPI: {
    description:
      "Return on Invested Capital (i.e. ROIC) is a ratio that takes a business’s Net Profits and divide it by the total capital raised. Investors use this ratio to assess the return a business has generated from the capital raised.",
    learnMoreAbout: "ROIC",
    typeformUrl: TypeformUrls.ROIC
  },
  RNOA: {
    description:
      "Your RNOA (i.e. Return on Net Operating Assets) is one of the key metrics used in determining your grades.",
    learnMoreAbout: "RNOA",
    typeformUrl: TypeformUrls.RNOA
  },
  RNOA_KPI: {
    description:
      "Return on Net Operating Assets (i.e. RNOA) is a ratio that takes a business’s Net Profits and divide it by total operating assets. Investors use this ratio to assess how much income they earned with the assets they own.",
    learnMoreAbout: "RNOA",
    typeformUrl: TypeformUrls.RNOA
  },
  SHARES_OUTSTANDING: {
    description: "The number of shares issued to investors less any buybacks.",
    learnMoreAbout: "Shares Outstanding",
    typeformUrl: TypeformUrls.SHARES_OUTSTANDING
  },
  STOCK_PRICE: {
    description:
      "Stock Price is a ratio that takes your business’s value and divide it by total outstanding shares. Investors use this ratio to assess the attractiveness of a business.",
    learnMoreAbout: "Stock Price",
    typeformUrl: TypeformUrls.STOCK_PRICE
  },
  STOCK_RETURN: {
    description: "",
    learnMoreAbout: "Stock Return",
    typeformUrl: TypeformUrls.STOCK_RETURN
  },
  TIME_VALUE_OF_MONEY: {
    description:
      "It is the value taking future cash flows and adjusting those cash flows to the present time. For example, if you are expecting to receive $100 a year from now, the present value (i.e. current value) will be different due to the time value of money.",
    learnMoreAbout: "Time Value of Money",
    typeformUrl: TypeformUrls.TIME_VALUE_OF_MONEY
  },
  UTILIZATION: {
    description:
      "It is how often your machines are operating and employees working over a 24hr period throughout the year. 100% utilization for machines means that your machines were operating 24hrs per day 7 days per week for the entire year. 100% machine and/or human utilization can be costly.",
    learnMoreAbout: "Utilization",
    typeformUrl: TypeformUrls.UTILIZATION
  }
};

export default TypeformContent;



// WEBPACK FOOTER //
// ./src/components/typeform/TypeformContent.js